<template>
  <div
    id="app_child_frame"
    v-show="$store.state.app.app_isSHow"
    @mousedown="operation"
    @mouseup="operation"
  >
    <!--顶部栏-->
    <top-bar></top-bar>
    <btn-hide-top-bar v-if="isPC"></btn-hide-top-bar>
    <p class="top_bar_placeholder"></p>

    <div class="important_part">
      <my-header
        v-if="
          $store.state.app.view_pattern == 'pc' ||
          $store.state.myRender.common.fixed_header == 'true'
            ? true
            : false
        "
      ></my-header>
      <div class="mb_body_view" @scroll="mbScroll">
        <my-header
          v-if="
            $store.state.app.view_pattern == 'mb' &&
            $store.state.myRender.common.fixed_header != 'true' &&
            ($store.state.myRender.common.setting.logoTitleRadio ||
              $store.state.myRender.common.setting.headerNavRadio ||
              $store.state.myRender.common.setting.multiLanguageOpen)
          "
        ></my-header>
        <my-banner></my-banner>
        <my-body></my-body>
        <my-footer></my-footer>
        <div class="footer_placeholder" v-if="footer_placeholder_show"></div>
        <!-- contact us 手机端 联系我们 -->
        <contactUs
          v-if="$store.state.app.view_pattern === 'mb' && $store.state.myRender.common.contact_us && $store.state.myRender.common.contact_us.contact_us_show"></contactUs>
        <backTop
          class="mb-back-top"
          v-show="
            $store.state.app.view_pattern === 'mb' &&
            $store.state.myRender.common.setting.returnTopRadio
          "
          @bindClickBackTop="backToTop"
        ></backTop>

      </div>
      <!-- 图册预览 -->
      <template v-if="$store.state.app.view_pattern === 'mb'">
        <atlas_pc_look v-if="$store.state.atlas_look.is_Show"></atlas_pc_look>
      </template>

      <div
        id="position_fixed_background_layer"
        :style="{
          backgroundColor:
            body_b.radio_val !== 'hidden' ? body_b[body_b.radio_val].color : '',
          backgroundImage:
            body_b.radio_val !== 'hidden' && body_b[body_b.radio_val].img !== ''
              ? 'url(' + body_b[body_b.radio_val].img + ')'
              : 'none',
          backgroundSize:
            body_b.radio_val !== 'hidden'
              ? body_b[body_b.radio_val].background_size
              : 'auto',
          backgroundRepeat:
            body_b.radio_val !== 'hidden'
              ? body_b[body_b.radio_val].background_repeat
              : 'repeat',
          backgroundPosition:
            body_b.radio_val !== 'hidden'
              ? body_b[body_b.radio_val].background_position
              : '0% 0%',
        }"
        v-if="
          $store.state.myRender.private &&
          $store.state.myRender.private.fixed_background_isOpen == 'true'
            ? true
            : false
        "
      ></div>
    </div>
    <!-- <basic_addProduct v-if='baseTag' :editId='2' :showTag.sync='baseTag'></basic_addProduct> -->
    <!-- <basic_addArticle v-if='baseTag' :articleType='3' :showTag.sync='baseTag'></basic_addArticle> -->
    <!-- <el-button @click='baseTag = true'>添加文章</el-button> -->
    <!-- <basic_addAtlas></basic_addAtlas> -->
    <!--mb独有-->
    <template v-if="$store.state.app.view_pattern === 'mb'">
      <div class="jz_alert mobi_setting_tips" id="mb-view">
        <div class="jz_alert_content">
          <div>{{$t('view_index_59')}}</div>
        </div>
      </div>
      <mb_row_isShow></mb_row_isShow>
      <mb_designer_btn></mb_designer_btn>

      <!--mb的编辑-->
      <my-mb-edit v-if="$store.state.row.mb_edit.isShow"></my-mb-edit>
      <my_footnav_edit v-if="$store.state.app.footnav_edit.isShow"></my_footnav_edit>
    </template>

    <!--pc下左侧栏-->
    <template v-if="$store.state.app.view_pattern === 'pc'">
      <left-sidebar
        v-if="$store.state.left_sidebar.dialogVisible"
      ></left-sidebar>
      <left-btn v-if="!$store.state.row.edit_mongolia"></left-btn>

      <!-- 上半个蒙层 -->
      <div
        class="row_edit_mongolia upper_mongolia"
        v-if="$store.state.row.edit_mongolia"
        @click="row_edit_close"
      ></div>

      <!-- 下半个蒙层 -->
      <div
        class="row_edit_mongolia lower_mongolia"
        v-if="$store.state.row.edit_mongolia"
        @click="row_edit_close"
      ></div>

      <!-- 左半个蒙层 -->
      <div
        class="row_edit_mongolia left_mongolia"
        v-if="$store.state.row.edit_mongolia_horizontal"
        @click="row_edit_close"
      ></div>

      <!-- 右半个蒙层 -->
      <div
        class="row_edit_mongolia right_mongolia"
        v-if="$store.state.row.edit_mongolia_horizontal"
        @click="row_edit_close"
      ></div>

      <!-- 图册预览 -->
      <atlas_pc_look v-if="$store.state.atlas_look.is_Show"></atlas_pc_look>
    </template>
    <!-- 素材保存 -->
    <material_save_dialog
      v-if="$store.state.app.material_save_isShow"
    ></material_save_dialog>

    <!-- 通栏加到指定栏目 -->
    <my_add_dialog
      v-if="$store.state.page_add_row.isShow"
      @close="my_add_dialog_close"
      type="page_add_row"
      @confirm="set_row_page(arguments)"
    ></my_add_dialog>

    <main_dialog
      v-if="$store.state.main_dialog.main_dialog_isShow"
    ></main_dialog>


    <resource_store
    class="resource_store_style"
      :public_materia_url="publicMateriaUrl"
      v-if="$store.state.image_upload.showTag && ($store.state.image_upload.showIconLibrary || $store.state.image_upload.showFontIcon || $store.state.image_upload.isOld)"
      :url="baseUrl"
      :limit="$store.state.image_upload.fileLimit"
      :popstyle="true"
      :showtype="$store.state.image_upload.fileType"
      @showselect="showselect"
      @closepage="closepage"
      :filetype="$store.state.image_upload.fileType"
      :attribute="0"
      :filterplatform="$store.state.image_upload.defaultFilterPlatform"
      :left_tabs="left_tabs"
      :logo_url="logo_url"
      source='jpt'
    >
      <template slot="c_1">
        <div>
          <img-store :limitnum="$store.state.image_upload.fileLimit"></img-store>
        </div>
      </template>
      <template slot="c_2" v-if="$store.state.image_upload.showFontIcon">
        <font-icon-store :limitnum="$store.state.image_upload.fileLimit"></font-icon-store>
      </template>
      <template slot="c_3">
        <div>
          <img-more></img-more>
        </div>
      </template>
    </resource_store>

<!--新版资源库-->
<!-- npm i ydyl-file-center@2.0.10 --registry http://npm.idc7x24.cn -->
<!-- locale 说明 en: 英语 zh-CN: 中文(简体)zh-TW: 中文(繁体) -->
    <ydyl-file-center      
      :locale="ydylLang"
      v-show="!$store.state.image_upload.showIconLibrary && !$store.state.image_upload.showFontIcon && !$store.state.image_upload.isOld"
      :visible.sync="$store.state.image_upload.showTag"
      :configs="ydyl_file_configs"
      :options="getFileInfo"
      @change="onChange"
      @close="closepage"
    />


    <link_dialog v-if="$store.state.set_link.link_dialog_show"></link_dialog>
    <add_form v-if="$store.state.add_form.add_form_show"></add_form>
    <add_form_item
      v-if="$store.state.add_form_item.add_form_item_show"
    ></add_form_item>
    <!-- <test></test> -->
    <my_row_contextmenu_dialog
      v-if="$store.state.row_contextmenu_dialog.isShow"
    ></my_row_contextmenu_dialog>
    <my_anchor_set v-if="$store.state.anchor.popShow"></my_anchor_set>
    <!--历史记录(pc独有)-->
    <template>
      <historical_record></historical_record>
    </template>
    <submit_form_index></submit_form_index>
    <video_dialog></video_dialog>
    <backTop
      class="pc-back-top"
      v-show="
        $store.state.app.view_pattern === 'pc' &&
        $store.state.myRender.common.setting.returnTopRadio
      "
      @bindClickBackTop="backToTop"
    ></backTop>
    <!-- contactUs 联系我们删除 -->
    <contactUs
      v-if="$store.state.app.view_pattern === 'pc' && $store.state.myRender.common.contact_us && $store.state.myRender.common.contact_us.contact_us_show"></contactUs>
    <!-- 手机设置弹框 -->
    <right_set v-show="
        $store.state.app.view_pattern === 'mb' &&
        $store.state.right_set.dialogVisible
      "></right_set>

    <ul id="full-page-nav"
        v-if="isFullPage"
        :class="['full-page-nav',`full-page-nav-style-${$store.state.myRender.private.fullPageStyleType||0}`]">
      <li v-for="(item,index) in navList">{{ item }}</li>
    </ul>
    <!-- 显示浮框  -->
    <basic_floating_frame v-if="$store.state.myRender.private.floatingFrameOpen"
                          :module="$store.state.myRender.private.floatingFrameStyle"></basic_floating_frame>
  </div>
</template>

<script>
import i18n from '../language/index'

import TopBar from "./public/topBar";
import btnHideTopBar from "./public/btnHideTopBar";
import MyHeader from "./public/header";
import MyBody from "./public/body";
import MyFooter from "./public/footer";
import LeftSidebar from "./left_sidebar/index";
import LeftBtn from "./left_sidebar/btn";
import myBanner from "@/view/public/banner";
import link_dialog from "@/view/dialog";
import add_form from "@/view/form_dialog/add_form";
import add_form_item from "@/view/form_dialog/add_form_item";
import test from "@/view/test";
import my_row_contextmenu_dialog from "@/components/my_row_contextmenu_dialog";
import MyMbEdit from "@/components/my_mb_edit";
import mb_row_isShow from "@/components/mb_row_isShow";
import historical_record from "@/components/historical_record";
import material_save_dialog from "@/components/material_save_dialog";
import my_anchor_set from "@/components/my_anchor_set";
import submit_form_index from "@/components/set_link/components/submit_form/index";
import video_dialog from "../components/set_link/components/pop_video";
import backTop from "@/view/back_top";
import atlas_pc_look from "../components/atlas_look/pc_look";
import my_add_dialog from "@/components/my_add_button/my_add_dialog.vue";
import right_set from "./right_set/index";
import {find_page, gen_id} from "@/base/base";
import {copyWidget, setRelationWidget, navDetail} from "@/api/app";
import mb_designer_btn from "@/components/mb_designer_btn";
import my_footnav_edit from "@/components/my_footnav_edit";
import FullPage from "../base/fullPage";
import {flatTree} from './../utils/utils'
import store from "../vuex/store";
import contactUs from "@/view/contact_us"
import imgStore from "@/components/my_img_selecter/img_store.vue"
import imgMore from "@/components/my_img_selecter/img_more.vue"
import fontIconStore from '@/components/my_img_selecter/font_icon_store.vue'

import { getYdylFileLang } from '@/base/cookie'

export default {
  name: "index",
  data() {
    return {
      // 显示隐藏
      //$store.state.image_upload.showTag
      // 文件中心配置
      ydylLang: getYdylFileLang(),
      ydyl_file_configs: {
        baseURL:process.env.VUE_APP_YYP,//api请求地址
        folderModule: 1,//  模块id, 1 海外建站 2 邮件营销 3 投放中心 4 社媒营销 5 品牌建设 6 客户管理 7 其他
        zIndex:4000,
      },
      // 选择限制，不传表示不限制
      ydyl_file_options:{
        limit: 15,             // 接受的文件数量， 默认 1， 0表示不限制 （前端）
        fileFormats: ["jpeg","jpg","png","webp"], // 格式：JPG、JPEG、PNG MP4、MOV,  数组
      },
      publicMateriaUrl: process.env.VUE_APP_PUBLIC_MATERIA_URL,
      logo_url: process.env.BASE_LOGO_URL,
      first_model: "",
      backToTopFlag: false,
      mbBackToTopFlag: false,
      baseTag: false,
      baseUrl: process.env.BASE_FILE_API,
      filterPlatform: [{value: 'jpt', label: i18n.t('view_index_60')}],
      imgUrl: [],
    };
  },
  components: {
    imgStore,
    imgMore,
    fontIconStore,
    video_dialog,
    TopBar,
    btnHideTopBar,
    MyHeader,
    MyBody,
    MyFooter,
    LeftSidebar,
    LeftBtn,
    myBanner,
    link_dialog,
    add_form,
    add_form_item,
    test,
    my_row_contextmenu_dialog,
    MyMbEdit,
    mb_row_isShow,
    historical_record,
    material_save_dialog,
    my_anchor_set,
    submit_form_index,
    backTop,
    atlas_pc_look,
    my_add_dialog,
    right_set,
    mb_designer_btn,
    my_footnav_edit,
    contactUs // 联系我们
  },
  methods: {
    onChange(data){
      if (data.constructor !== Array){
        data = [data]
      }
      data.map(e => {
        e.path = e.fileUrl;
        e.fileName = e.name;
        e.filePath = e.fileUrl;
      });
      this.showselect(data)
    },
    mbScroll({target: {scrollTop}}) {
      this.throttle.call(
        this,
        (_) => {
          this.mbBackToTopFlag = scrollTop > 60;
          this.$store.state.myRender.common.fixed_back_top.mbShowBtn =
            this.mbBackToTopFlag && this.$store.state.app.view_pattern === "mb";
        },
        300,
        333
      )();
    },
    row_edit_close() {
      this.templet.row_Mongolia_close();
      this.templet.main_dialog_reset();
    },

    // 点击图片回到顶部方法，加计时器是为了过渡顺滑
    backToTop() {
      if (this.isFullPage && this.$store.state.app.view_pattern === "pc") {
        window.fullPage && window.fullPage.go(0)
      }
      if (this.$store.state.app.view_pattern === "mb") {
        $(".mb_body_view").animate(
          {
            scrollTop: 0,
          },
          0
        );
      } else {
        $("html,body").animate(
          {
            scrollTop: 0,
          },
          0
        );
      }
    },
    throttle(fn, delay = 90, mustRunDelay = 111) {
      // 高频节流
      let timer = null;
      let startTime;

      return (args) => {
        let stamp = +new Date();
        clearTimeout(timer);
        if (!startTime) startTime = stamp;
        if (stamp - startTime >= mustRunDelay) {
          fn.call(this, args);
          startTime = stamp;
        } else {
          timer = setTimeout(() => {
            fn.call(this, args);
          }, delay);
        }
      };
    },
    // 为了计算距离顶部的高度，当高度大于60显示回顶部图标，小于60则隐藏
    scrollToTop() {
      this.throttle.call(
        this,
        (_) => {
          let scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          this.scrollTop = scrollTop;
          this.backToTopFlag = this.scrollTop > 60;
          this.$store.state.myRender.common.fixed_back_top.pcShowBtn =
            this.backToTopFlag && this.$store.state.app.view_pattern === "pc";
        },
        300,
        333
      )();
    },
    my_add_dialog_close() {
      this.$store.commit("page_add_row/SET_isShow", false);
    },
    set_row_page(ag) {
      const arr = ag[0];
      const is_copy_row = ag[1];

      if (is_copy_row) {
        //直接复制挂件
        this.direct_copy_row(arr);
      } else {
        //设置关联挂件
        this.setRelationWidget(arr);
      }

      // const now_row = this.$store.state.page_add_row.row;
      // if (now_row) {
      //   now_row.data.pages = pages;
      // }
    },

    //传递页面参数
    get_page_data(arr, type = "no_now_page") {
      //把弹框选中的ids转成对象
      const pages = arr.map((item) => {
        const obj = find_page(item, this.$store.state.app.pages, "id");
        //去除当前页面
        if (type === "no_now_page") {
          if (obj.name != this.$store.state.app.now_page) {
            return obj.name;
          }
        } else {
          return obj.name;
        }
      });
      const pages_str = pages.join(",");
      return pages_str;
    },

    //直接复制
    direct_copy_row(arr) {
      const now_row = this.$store.state.page_add_row.row;
      copyWidget({
        widgets_id: now_row.widgets_id,
        fromPage: this.$store.state.app.now_page,
        toPage: this.get_page_data(arr),
      }).then((e) => {
        if (e.code == 200) {
          this.$message.success({
            showClose: true,
            message: e.message,
          });
        } else {
          this.$message.error({
            showClose: true,
            message: i18n.t('view_index_61'),
          });
        }
      });
    },

    //设置关联挂件
    setRelationWidget(arr) {
      const now_row = this.$store.state.page_add_row.row;
      setRelationWidget({
        widgets_id: now_row.widgets_id,
        pages: this.get_page_data(arr, "has_now_page"),
      }).then((e) => {
        if (e.code == 200) {
          this.$message.success({
            showClose: true,
            message: i18n.t('view_index_62'),
          });
          this.templet.p_init();
        } else {
          this.$message.error({
            showClose: true,
            message: i18n.t('view_index_63'),
          });
        }
      });
    },

    close_row_page() {
      this.$store.commit("page_add_row/SET_isShow", false);
      this.$store.commit("page_add_row/SET_row", null);
    },
    //加入公共挂件池
    row_add_common(now_row) {
      //检查当前row是否存在标志位
      if (!now_row.data.public_rows_id) {
        //用于和public_rows中的挂件做关联
        now_row.data.public_rows_id = gen_id();
      }

      //查看公共池，有则覆盖，无则插入
      this.templet.look_public_rows(now_row);
    },
    operation() {
      this.$store.commit("app/set_operation", true);
      this.templet.theme_id_validation();
    },
    animation() {
      const implement = this.$store.state.moduleAnimation.implement;
      //const w = $(window).width();
      for (let i = 0; i < implement.length; i++) {
        const id = implement[i].module.widgets_id;
        const dom = document.querySelector(
          '[data-animation-key="j-' + id + '"]'
        );
        //判断这个挂件是否在当前屏幕下
        //const left = $(dom).offset().left;
        // if(left < w){
        //   implement[i].vue.animation(dom);
        // }
        //如果是在横幅中的
        if ($(dom).parents(".full_screen_banner").length > 0) {
          //只有当前选中的横幅
          if (
            $(dom).parents(".swiper-slide").hasClass(".swiper-slide-active")
          ) {
            implement[i].vue.animation(dom);
          }
        } else {
          implement[i].vue.animation(dom);
        }
      }
    },
    initFullPage() {
      if (!this.isFullPage) {
        return
      }

      let scrollType = this.$store.state.app.scrollType

      let that = this
      this.$nextTick(() => {
        let fullPage = new FullPage({
          el: '.mb_body_view',                            // selector of contain
          slideTime: 600,                               // time of slide
          continuous: false,                            // create an infinite feel with no endpoints
          mode: 'wheel,nav:full-page-nav',               // mode of fullpage
          start: 0,                                     // which page will display when install
          easing: '',                                // easing('ease','ease-in','ease-in-out' or use cubic-bezier like [.33, 1.81, 1, 1];
          callback: function (index, thisPage) {       // callback when pageChange
            let backTopVisible = index > 0 && that.$store.state.app.view_pattern === 'pc' && that.$store.state.myRender.common.setting.returnTopRadio
            backTopVisible ? $('.pc-back-top').show() : $('.pc-back-top').hide()
            that.$store.commit('app/setFullPageCurrentIndex', index);
            that.animation();
          }
        });
        if (that.$store.state.app.view_pattern === 'pc' && that.$store.state.myRender.common.setting.returnTopRadio) {
          $('.pc-back-top').hide() // 第一屏隐藏backTop按钮
        }
        window.fullPage = fullPage

        setTimeout(() => {
          that.animation();
        }, 500)
        // 底部类型变化的时候，重新设置一下高度
        that.$watch('$store.state.myRender.private.fullPageFooterType', function () {
          fullPage.resetHeight()
          fullPage.goLastPageOrFooter()
        })
        that.$watch('$store.state.myRender.private.fullPageTopNavType', function () {
          fullPage.resetHeight()
          fullPage.go(0)
        })
        that.$watch('$store.state.myRender.private.banner_isShow', function (val) {
          setTimeout(() => {
            window.fullPage && window.fullPage.toggleBannerVisible(val)
          }, 20)
        })
        that.$watch('$store.state.myRender.common.footer_display', function (val) {
          if (String(val) === 'true') {
            if (this.$store.state.myRender.private.fullPageFooterType === 'hidden') {
              let footerType = scrollType === 'col' ? 'type0' : 'typeRow1'
              this.$store.commit('myRender/setFullPageFooterType', footerType)
            }
          } else {
            this.$store.commit('myRender/setFullPageFooterType', 'hidden')
          }
        })
      })
    },
    showselect(data) {
      console.log(data,"kkkkjjjhggg")
      console.log(this.$store.state.image_upload.fileLimit,"fileLimit")
      console.log(this.$store.state.image_upload.fileType,"fileType")
      console.log(this.$store.state.image_upload.defaultFilterPlatform,"defaultFilterPlatform")
      this.$store.state.image_upload.imgFile(data)
      setTimeout(() => {
        this.$store.commit('image_upload/set_showTag', false);
        this.$store.commit("image_upload/set_showFontIcon", false);
        this.$store.commit("image_upload/set_showIconLibrary", false);
        this.$store.commit("image_upload/set_isOld", false);
      }, 10)
    },
    closepage(data) {
      this.$store.commit('image_upload/set_showTag', false);
      this.$store.commit("image_upload/set_showFontIcon", false);
      this.$store.commit("image_upload/set_showIconLibrary", false);
      this.$store.commit("image_upload/set_isOld", false);

    }
  },
  computed: {
    getFileInfo(){
      let limitRes = this.$store.state.image_upload.fileLimit;
      let fileFormatsRes = ['jpeg','jpg','png','webp'];
      let fileType = this.$store.state.image_upload.fileType;
      if (fileType === 1){       //图片
        fileFormatsRes = ['jpeg','jpg','png','webp'];
      }else if (fileType === 3){ //视频
        fileFormatsRes = ['swf','mp4']
      }else if(fileType === 9){  //下载文件
        fileFormatsRes = ["rar","zip","ttf","doc","docx","xls","xlsx","xlsm","pdf","ppt","pptx","swf","MP4","png","jpg","gif"];
      }else {
        fileFormatsRes = ['jpeg','jpg','png','webp'];
      }
      let data = {
        limit:limitRes,
        fileFormats:fileFormatsRes,
      }
      return data;
    },
    isPC() {
      return this.$store.state.app.view_pattern === 'pc'
    },
    left_tabs() {
      if (this.$store.state.image_upload.fileType === this.$store.state.image_upload.TYPE_MY_FILE) {
        return [{
          index: 'c_3',
          label: i18n.t('view_index_64')
        }]
      } else {
        if (this.$store.state.image_upload.showFontIcon) {
          //  label: '图标库',
          //   isShow: this.$store.state.image_upload.showFontIcon,
          return [{
            index: 'c_1',
            label: i18n.t('view_index_65')
          }, {
            index: 'c_2',
            label: i18n.t('view_index_66')
          }, {
            index: 'c_3',
            label: i18n.t('view_index_64')
          }]
        }
        return [{
          index: 'c_1',
          label: i18n.t('view_index_65')
        }, {
          index: 'c_3',
          label: i18n.t('view_index_64')
        }]
      }
    },
    watch_obj() {
      const myRender = this.$store.state.myRender;
      const obj = {
        header: myRender.header,
        body: myRender.body,
        footer: myRender.footer,
        full_screen_banner: myRender.full_screen_banner,
        private: myRender.private,
        common: myRender.common,
      };
      return JSON.parse(JSON.stringify(obj));
    },
    back_top_show() {
      if (this.$store.state.app.view_pattern === "mb")
        return (
          this.$store.state.myRender.common.fixed_back_top.show_back_top &&
          this.mbBackToTopFlag
        );
      else
        return (
          this.$store.state.myRender.common.fixed_back_top.show_back_top &&
          this.backToTopFlag
        );
    },
    footer_placeholder_show() {
      if (
        this.$route.name === "product" &&
        this.$store.state.app.view_pattern === "mb" && this.$store.state.myRender.common.displayContactRadio === 'block'
      ) {
        return true;
      } else {
        return false;
      }
    },
    body_b() {
      return this.$store.state.myRender.common.body_background;
    },
    isFullPage() {
      return this.$store.state.app.scrollType !== 'normal'
    },
    navList() {
      let num = this.$store.state.myRender.body.length
      let pageNum = this.$store.state.myRender.private.banner_isShow ? num + 1 : num
      let list = new Array(pageNum).fill(0).map((item, index) => index < 9 ? ('0' + String(index + 1)) : index + 1)
      return list
    },
  },
  watch: {
    '$store.state.image_upload.showTag'(val) {
      if(val) {
        $('html').addClass("el-popup-parent-imgPop--hidden")
      } else if($('.el-popup-parent-imgPop--dialog').length == 0 && !val){
        $('html').removeClass("el-popup-parent-imgPop--hidden")
      }
    },
    '$store.state.myRender.common.header_layout_row_setting'(val) {
      this.templet.reset_header_set_data()
    },
    //监听全局渲染对象，从而加入历史记录
    watch_obj: {
      handler: function (val, oldVal) {
        //当还没做任何操作前，不会插入历史记录,并且保存中也不会触发
        if (
          this.$store.state.app.is_operation &&
          !this.$store.state.app.save_loading &&
          this.$store.state.app.is_add_history
        ) {
          //判断，前后一致，不加入历史
          if (JSON.stringify(val) === JSON.stringify(oldVal)) {
            return;
          }

          this.$store.commit("app/SET_is_change", true);
          this.templet.module_add_historical();
        }
      },
      deep: true,
    },
    //左侧栏目打开，编辑框关闭
    "$store.state.left_sidebar.dialogVisible"(val) {
      if (val) {
        this.$store.commit("main_dialog/Change_main_dialog_isShow", false);
      } else {
        this.$store.state.app.addModule_col = null;
      }
    },

    //编辑栏打开，左侧栏关闭
    "$store.state.main_dialog.main_dialog_isShow"(val) {
      if (val) {
        this.$store.commit("left_sidebar/set_dialog", false);
      }
    },
    '$store.state.app.view_pattern'(val) {
      if (val === 'mb') {
        window.fullPage && window.fullPage.destroy()
      } else {
        this.isFullPage && this.initFullPage()
      }
    },
    '$store.state.app.image_upload.showTag'(val) {
      console.log('showTag changed', val)
      console.trace()
    }
  },
  created() {
    $.myMongoliaOpen($(".preview_frame")[0]);
    store.commit('app/set_pageDataLoading', true)
  },
  destroyed() {
    window.removeEventListener("scroll", this.scrollToTop);
    window.fullPage && window.fullPage.destroy()
  },
  mounted() {
    setTimeout(() => {
      // this.$store.commit('app/set_role', 'designer'); //测试代码 要删掉  @todo warning
    }, 2000)
    const that = this;
    this.templet.getNavList().then((res) => {
      let navList = this.$store.state.app.navListData
      navList = flatTree(navList)
      let path = this.$route.name
      let nav = navList.find(item => item.theme_name === path)
      let scrollType = (nav || {}).scroll_type || 'normal'
      this.$store.commit('app/setScrollType', scrollType)

      this.templet.p_init(() => {
        if (scrollType && scrollType !== 'normal' && this.$store.state.app.view_pattern === 'pc') {
          this.initFullPage()
        }
      })

    })


    this.templet.getProduct();
    // 新闻列表
    this.templet.getArticle(1);
    // 帮助列表
    this.templet.getArticle(2);
    // 案例列表
    this.templet.getArticle(3);
    // 新闻分类列表
    this.templet.getArticleType(1);
    // 案例分类列表
    this.templet.getArticleType(2);
    // 案例分类列表
    this.templet.getArticleType(3);
    this.templet.getProType();
    this.templet.getFormList();
    //this.templet.get_pags();//获取列表列表
    this.templet.get_home(); //请求角色
    this.templet.get_anchor("index");
    this.templet.getSearchsParams(); //获取搜索参数列表

    //顶部固定
    //this.globalScroll(this.templet.fixed_header.bind(this.templet));

    this.$store.dispatch("historical/websql_create"); //创建websql

    window.addEventListener("scroll", this.scrollToTop);

    $(window).scroll(function (e) {
      //console.log('pc_scroll')
      that.templet.fixed_header();
      that.animation();
    });

    $(".mb_body_view").scroll(function (e) {
      //console.log('mb_scroll')
      that.animation();
    });

    //本地测试使用
    //this.$store.commit('myRender/test_data');
    //this.templet.data_null();

    // setTimeout(() => {
    //   const obj = {
    //     header: this.$store.state.myRender.header,
    //     body: this.$store.state.myRender.body,
    //     footer: this.$store.state.myRender.footer,
    //     full_screen_banner: this.$store.state.myRender.full_screen_banner,
    //     private: this.$store.state.myRender.private,
    //     common: this.$store.state.myRender.common
    //   };
    //   console.log("数据", obj);
    // }, 1000);
  },
};
</script>

<style lang="scss" scoped>
@import "~@/css/global-variable.scss";

.top_bar_placeholder {
  height: $topBar-height;
  transition: height 0.5s;
}

.footer_placeholder {
  height: 50px;
}
.resource_store_style {
  /deep/ .el-dialog__wrapper {
    overflow: hidden;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/index.vue